import api from "../../API/apiConfig";

//1. Add new Event
export const createEvent = async (eventData) => {
    return await api.post(`events/add`, eventData);
  }
//2. Get All Events By Type and Member ID
export const ViewMemberEvent = async (type, id) => {
    try {
      const response = await api.get(`/events/${type}/${id}`);
      console.log("API Response:", response); 
      return response;
    } catch (error) {
      console.error("Error in viewMemberLogCall:", error);
      throw error;
    }
  };
  //3. Delete Event
  export const deleteEvent = async (eventId) => {
    return await api.delete(`events/delete/${eventId}`);
  }
  //4. Event Detail
  export const getEventDetail = async (eventId) => {
    return await api.get(`events/detail/${eventId}`);
  }
  //5. Update Event
  export const updateEvent = async (eventId, eventData) => {
    return await api.put(`events/update/${eventId}`, eventData);
  }